import {
  LOGIN_ADMIN,
  LOADING_COMPLETE,
  LOAD_ADMIN_ERROR,
  LOAD_ADMIN_SUCCESS,
  LOGOUT_ADMIN,
  RESET_AUTH_ERRORS,
  LOGIN_ADMIN_ERROR,
} from '../actions/constants'

const initialState = {
  token: localStorage.getItem('token'),
  loading: null,
  admin: null,
  authError: [],
  isAuthorized: null,
}

const auth = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGIN_ADMIN:
      return {
        ...state,
        token: payload,
        loading: false,
        authError: [],
        isAuthorized: null,
      }
    case LOGIN_ADMIN_ERROR:
      return {
        ...state,
        loading: false,
        authError: payload,
        isAuthorized: false,
      }
    case LOAD_ADMIN_SUCCESS:
      const { token, ...rest } = payload
      localStorage.setItem('token', token)
      return {
        ...state,
        token,
        admin: { ...rest },
        isAuthorized: true,
        authError: [],
        loading: false,
      }
    case LOAD_ADMIN_ERROR:
      localStorage.removeItem('token')
      return {
        ...state,
        token: null,
        admin: null,
        isAuthorized: false,
        authError: payload,
        loading: false,
      }
    case LOADING_COMPLETE:
      return {
        ...state,
        loading: false,
      }
    case RESET_AUTH_ERRORS:
      return {
        authError: [],
      }
    case LOGOUT_ADMIN:
      localStorage.removeItem('token')
      return {
        ...state,
        token: null,
        admin: null,
        isAuthorized: false,
        authError: [],
        loading: false,
      }
    default:
      return state
  }
}

export default auth
